import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import routes from './routes';
import axios from 'axios'
import {SYS} from '@/config'

Vue.use(VueRouter);

Vue.prototype.navigateTo = function(link) {
	if (this.$route.fullPath.includes('/window/')) {
		this.$router.push(`/window${this.$router.resolve(link).href}`);
	} else {
		const resolved = this.$router.resolve(link);
		if (resolved.route.fullPath !== this.$route.fullPath) {
			this.$router.push(link);
		}
	}
};
Vue.prototype.navigateBack = function(n = -1) {
	this.$router.go(n);
};
Vue.prototype.redirectTo = function(link) {
	this.$router.replace(link);
};
Vue.prototype.windowTo = function(link) {
	window.open(`/window${this.$router.resolve(link).href}`, '_blank', `width=1400,height=900,top=${(window.innerHeight-900)/2},left=${(window.innerWidth-1400)/2}`);
};

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes
});

const app = new Vue();
router.beforeEach((to, from, next) => {
	axios.get(`//${window.location.host}/version.json?t=${new Date().getTime()}`).then(res => {
		if (res.status === 200) {
			if (window.sysVersion && window.sysVersion != res.data.version) {
				if (SYS == 'digital' || SYS == 'outlet_asset_digital') {
					window.location.reload();
				} else {
					app.$confirm({
						message: '检测到新版本已发布，请刷新页面后使用',
						buttonName: '刷新页面',
						cancelButton: false,
						resolve: () => {
							window.location.reload();
						}
					});
				}
			} else {
				window.sysVersion = res.data.version;
			}
		}
	}).catch(e => {
		console.log(e);
	});

	if (!to.meta.loginFree) {
		if (!store.state.session) {
			next(`/login?redirect=${to.fullPath}`);
		} else if (to.name && !to.meta.authFree && !app.auth(to.name)) {
			next('/');
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router